import { setWindowLocation } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import {
    getRedirectUrl,
    trackNewUser,
    updateStatsigSession,
} from '../../utils/statsig';
import { getLookupMethodsConfig } from '../beta/lookupMethodsConfig';
import { getSocialConfigErrors } from '../beta/socialErrorsConfig';

export const getSignupConfiguration = ({
    request,
    gaSettings,
    captcha,
    socialSSOSettings,
    skipSocialCalls,
    socialDataMock,
    fp,
    referrer,
    featureFlags,

    dispatchUpdateFormType,
    redirectToLogInAction,
}: any) => {
    const _request = { ...request };
    const isReferrerMyTickets =
        decodeURIComponent(referrer).includes('/mytickets');

    const successSignupRedirect = async (url: string, userId?: string) => {
        await updateStatsigSession(userId);
        trackNewUser(referrer);
        if (url) {
            const redirectUrl = getRedirectUrl(url);
            const decodedRedirectUrl = decodeURIComponent(redirectUrl);

            setWindowLocation(decodedRedirectUrl);
        }
    };

    if (isReferrerMyTickets) {
        return {
            header: {
                titleText: gettext('What email did you use to buy tickets?'),
            },
            lookupMethods: getLookupMethodsConfig(),
            signupMethods: {
                success: (response: any) => {
                    return successSignupRedirect(
                        response?.redirectUrl,
                        response?.id,
                    );
                },
                error: {
                    DEFAULT_ERROR: () => ({}),
                    HAS_PASSWORD: {
                        getNotification: () => ({
                            ctaMessage: gettext('Log in'),
                            ctaAction: redirectToLogInAction,
                        }),
                    },
                },
            },
            socialMethods: {},
            forgotPasswordMethods: {},
            analytics: {
                request: _request,
                gaSettings,
            },
            captcha,
            request: _request,
            social: {},
            featureFlags,
            fp,
            referrer,
            hideDivider: true,
            showBackButton: true,
            isUsingOrderId: false,
        };
    }

    return {
        header: {
            titleText: gettext('Create an account'),
            headerLinkProps: {
                onHeaderClick: redirectToLogInAction,
                linkTo: '/signin/',
                linkText: gettext('Log in'),
                linkTestid: 'go-to-login',
            },
        },
        lookupMethods: getLookupMethodsConfig(),
        signupMethods: {
            success: (response: any) => {
                return successSignupRedirect(
                    response?.redirectUrl,
                    response?.id,
                );
            },
            error: {
                DEFAULT_ERROR: () => ({}),
                HAS_PASSWORD: {
                    getNotification: () => ({
                        ctaMessage: gettext('Log in'),
                        ctaAction: redirectToLogInAction,
                    }),
                },
            },
        },
        socialMethods: {
            success: (response: any) => {
                return successSignupRedirect(
                    response?.redirectUrl,
                    response?.publicId,
                );
            },

            error: getSocialConfigErrors({ dispatchUpdateFormType }),
        },
        forgotPasswordMethods: {},
        analytics: {
            request: _request,
            gaSettings,
        },
        captcha,
        request: _request,
        social: {
            SSOSettings: socialSSOSettings,
            skipSocialCalls,
            socialDataMock,
            secondarySocialMethods: {
                facebook: true,
                apple: true,
            },
            disabledOptions: ['apple'],
        },
        featureFlags,
        fp,
        referrer,
    };
};
